/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, once) {

  'use strict';

  const nvcl_settings = drupalSettings.nvcl_settings;

  Drupal.behaviors.weaver = {

    backTop: function() {
      window.scrollTo(0,0);
    },

    initializeDigitalLibraryCards: function() {

      // scroll back to card when something inside is expanded
      const digitalCollapses = document.querySelectorAll('.resource-card .collapse');
      if (digitalCollapses == null) {
        return;
      }

      digitalCollapses.forEach((digitalCollapse) => {
        let digitalCollapseId = digitalCollapse.id;
        let digitalLink = document.querySelector('a[data-toggle="collapse"][data-target="#' + digitalCollapseId + '"]');
        
        $(digitalCollapse).on('shown.bs.collapse', function() {
          // scroll to the link
          digitalLink.scrollIntoView(true, {
            behavior: 'smooth'
          });
          digitalLink.classList.add('active');
        });
        
        $(digitalCollapse).on('hide.bs.collapse', function() {
          digitalLink.classList.remove('active');
        });
      });
    },

    initializeResponsiveTables: function() {
      const tables = document.querySelectorAll('.content table');

      if (tables.length <= 0) {
        return;
      }

      this.addResponsiveTablesText(tables);
    },

    addResponsiveTablesText: function(tables) {
      const horizontalTableScrollText = document.createElement('span');
      horizontalTableScrollText.classList.add('d-block', 'd-lg-none', 'text-center', 'font-weight-bold', 'font-size-xs');
      
      const scrollText = Drupal.t('Scroll left and right to view all columns >');
      horizontalTableScrollText.innerText = scrollText;
      
      // const horizontalTableScrollTextFirst = horizontalTableScrollText.cloneNode();
      // horizontalTableScrollTextFirst.innerText = scrollText;
      
      let i = 0;
      tables.forEach((table) => {
        let tableWrapper = document.createElement('div');
        tableWrapper.classList.add('table-responsive');

        let cloneText = horizontalTableScrollText.cloneNode(true);
        tableWrapper.appendChild(cloneText);

        let tableContainer = table.parentNode;
        tableContainer.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);
      });
    },

    searchCatalogue: function(searchQuery) {
      let catalogueSearchUrl = nvcl_settings.general.mynvcl_search_url;
      window.location.href = catalogueSearchUrl + searchQuery;
    },

    toggleIcons: function(trigger, state=null) {
      let icons = trigger.parentNode.querySelectorAll('.toggle-icon');
      if (icons.length <= 0) {
        return;
      }

      icons.forEach(icon => {

        if (state == null) {
          icon.classList.toggle('d-none');
        } else {
          if (icon.dataset.nvclState == state) {
            icon.classList.add('d-none');
          } else {
            icon.classList.remove('d-none');
          }
        }
      });
    },

    attach: function (context, settings) {

      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver', 'body', context)).each(function () {

        const weaver = Drupal.behaviors.weaver;

        weaver.initializeDigitalLibraryCards();
        weaver.initializeResponsiveTables();

        /////////////////////////////////////////
        // BACK TO TOP
        const backTop = document.getElementById('back-top');
        if (backTop != null) {
          backTop.addEventListener('click', function() {
            weaver.backTop();
          });
        }

        //////////////////////////////////////////
        // BODY add loaded class
        setTimeout(() => {
          document.body.classList.add('loaded');
        }, 200);


        ///////////////////////////////////////
        // COLLAPSE
        // enable all
        $('[data-toggle="collapse"]').collapse();
        const iconToggles = document.querySelectorAll('[data-toggle="collapse"]');
        if (iconToggles.length > 0) {
          iconToggles.forEach((iconToggle) => {
            iconToggle.addEventListener('click', (e) => {
              weaver.toggleIcons(iconToggle);
            });
          });
        }

        // if an anchor in URL is the ID of a collapse, open it
        const hash = window.location.hash.substr(1);
        const hashElement = document.getElementById(hash);
        
        if (hashElement != null && hashElement.classList.contains('resource-title') == false && hashElement.classList.contains('resource-card') == false) {

          let collapseElement;

          // if the element itself is the collapse
          if (hashElement.classList.contains('collapse')) {
            collapseElement = hashElement;
          
          } else {

            // if the element is a sibling of a collapse
            collapseElement = hashElement.parentNode.querySelector('.collapse');
            
            if (collapseElement != null) {
              $(collapseElement).collapse('show');
            }
          }
        }


        // keyboard enable the "More..." tab
        document.addEventListener('keydown', (e) => {
          if (e.code == 'Enter' && e.target.dataset.toggle == 'collapse') {
            let collapseTarget = document.querySelector(e.target.dataset.target);
            $(collapseTarget).collapse('toggle');
          }
        });


        ///////////////////////////////////////
        // HOME HERO

        // add special loading class to stop flicker of image sizing
        const heroImages = document.querySelectorAll('.hero-image img');

        if (heroImages != null) {
          heroImages.forEach((heroImage) => {
            setTimeout(() => {
              heroImage.classList.add('loaded');
            }, 500);
          });
        }

        ///////////////////////////////////////
        // POPOVERS
        // enable all popovers
        $('[data-toggle="popover"]').popover({
          html: true
        });

        ///////////////////////////////////////
        // SCROLLING

        // add class once 100px of scrolling
        window.addEventListener('scroll', (e) => {
          if (window.scrollY >= 100) {
            document.body.classList.add('scrolled-100');
          } else {
            document.body.classList.remove('scrolled-100');
          }
        });

        ///////////////////////////////////////
        // SEARCH
        // opens NVCL catalogue search
        const searchForm = document.getElementById('nvcl-search-catalogue-form');
        if (searchForm != null) {
          let searchButton = searchForm.querySelector('button[name="nvcl_search_submit"]');
          let searchInput = searchForm.querySelector('input[name="nvcl_search_catalogue"]');

          if (searchButton != null && searchInput != null) {
            searchButton.addEventListener('click', (e) => {
              e.preventDefault();
              let searchQuery = searchInput.value;
              if (searchQuery != '') {
                weaver.searchCatalogue(searchQuery);
              }
            });

            // launch search if Enter pressed while in Search input
            document.addEventListener('keydown', (e) => {
              if (e.code == 'Enter' && (e.target == searchInput || e.target == searchButton)) {
                let searchQuery = searchInput.value;
                weaver.searchCatalogue(searchQuery);
              }
            });
          }
        }

        // shifts search results page down to results
        const searchResults = document.querySelector('.view-id-nvcl_search.view-display-id-page_1 .view-content');
        if (searchResults != null) {
          searchResults.scrollIntoView({
            behaviour: 'smooth',
            block: 'start'
          });
        }

        const searchSolrResults = document.querySelector('.view-id-solr_search.view-display-id-page_1 .view-content');
        if (searchSolrResults != null) {
          searchSolrResults.scrollIntoView({
            behaviour: 'smooth',
            block: 'start'
          });
        }

        // inserts search term into results header
        const searchHeader = document.querySelector('.view-id-nvcl_search.view-display-id-page_1 .view-header');
        if (searchHeader != null) {
          const searchParams = new URLSearchParams(window.location.search);
          if (searchParams.has('search')) {
            searchHeader.innerHTML = searchHeader.innerHTML.replace('{{search_term}}', searchParams.get('search'));
          } else {
            searchHeader.innerHTML = searchHeader.innerHTML.replace('{{search_term}}', 'no search');
          }
        }

        const searchSolrHeader = document.querySelector('.view-id-solr_search.view-display-id-page_1 .view-header');
        if (searchSolrHeader != null) {
          const searchParams = new URLSearchParams(window.location.search);
          if (searchParams.has('search')) {
            searchSolrHeader.innerHTML = searchSolrHeader.innerHTML.replace('{{search_term}}', searchParams.get('search'));
          } else {
            searchSolrHeader.innerHTML = searchSolrHeader.innerHTML.replace('{{search_term}}', 'no search');
          }
        }

        ///////////////////////////////////////
        // SHARE COPY LINK
        // copies URL when clicked
        const shareLinks = document.querySelectorAll('.share-copy-link');
        if (shareLinks.length > 0) {
          shareLinks.forEach((shareLink) => {
            shareLink.addEventListener('click', () => {
              navigator.clipboard.writeText(window.location.href);
              shareLink.classList.add('active');
              setTimeout(() => {
                shareLink.classList.remove('active');
              }, 2000);
            });
          });
        }

        ///////////////////////////////////////
        // STICKY HEADER
        // adds class when scrolling
        const breadcrumbs = document.querySelector('.breadcrumbs-wrapper');
        if (breadcrumbs != null) {
          var breadcrumbsObserverOptions = {
            root: document.querySelector('.breadcrumbs-wrapper'),
            rootMargin: '0px 0px -100%',
          };
          var breadcrumbsObserver = new IntersectionObserver((entries) => {
              breadcrumbsObserverCallback(entries, breadcrumbsObserver, breadcrumbs);
          });
          breadcrumbsObserver.observe(breadcrumbs);
        } else {
          document.addEventListener('scroll', () => {
            if (document.body.classList.contains('sticky-header') == false) {
              document.body.classList.add('sticky-header');
            }
          });
        }

        // doesn't work on home page because no breadcrumbs
        const breadcrumbsObserverCallback = (entries, observer, breadcrumbs) => {
          entries.forEach((entry, breadcrumb) => {
            if (entry.isIntersecting) {
              document.body.classList.remove('sticky-header');
            } else {
              document.body.classList.add('sticky-header');
            }
          });
        };
                  
        ///////////////////////////////////////
        // TOOLTIPS

        let tooltipStatus = true;

        if (window.screen.width < 992) {
          tooltipStatus = false;
        }

				// enable all tooltips, but not on mobile
        if (tooltipStatus === true) {
			    const tooltipToggles = document.querySelectorAll('[data-toggle="tooltip"]');

          if (tooltipToggles.length > 0) {
            tooltipToggles.forEach((tooltipToggle) => {
              if ((tooltipToggle.dataset.target != null && tooltipToggle.dataset.target == 'takeover-menu') || tooltipToggle.classList.contains('btn-round')) {
                $(tooltipToggle).tooltip({
                  animation: true,
                  delay: { show: 500 },
                  trigger: 'hover',
                  template: '<div class="tooltip tooltip-yellow" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                });

               } else {

                $(tooltipToggle).tooltip({
                  animation: true,
                  delay: { show: 500 },
                  trigger: 'hover'
                });
              }
            });
          }
        }

        // Audio in modals
        const audioModals = document.querySelectorAll('.modal[data-audio="player"]');
        if (audioModals != null) {
          audioModals.forEach((audioModal) => {
            let audioPlayer = audioModal.querySelector('audio');
            if (audioPlayer !=  null) {
              $(audioModal).on('hide.bs.modal', function() {
                audioPlayer.pause();
              });
            }
          });
        }

        // YouTube in modals
        const youtubeModals = document.querySelectorAll('.modal[data-video="youtube"]');
        if (youtubeModals != null) {
          youtubeModals.forEach((youtubeModal) => {
            let youtubeIframe = youtubeModal.querySelector('iframe');

            $(youtubeModal).on('show.bs.modal', function() {
              if (youtubeIframe.getAttribute('src') == '') {
                youtubeIframe.setAttribute('src', youtubeIframe.dataset.url);
              }
            });

            $(youtubeModal).on('hide.bs.modal', function() {
              youtubeIframe.dataset.url = youtubeIframe.getAttribute('src');
              youtubeIframe.setAttribute('src', '');
            });
          });
        }

        // KEYBOARD SHORTCUTS
        document.onkeyup = function(e) {
          // toggle combined menu
          if (e.ctrlKey && e.altKey && e.which == 77) {
            let combinedMenu = document.getElementById('combined-menu');
            $(combinedMenu).modal('toggle');
          }

          // toggle Takeover Menus
          if (e.ctrlKey && e.altKey && e.which == 49) {
            let nav1 = document.querySelector('[data-item="nav1"]');
            Drupal.behaviors.weaver_takeover.toggleTakeover('menu', nav1);
          }
          if (e.ctrlKey && e.altKey && e.which == 50) {
            let nav2 = document.querySelector('[data-item="nav2"]');
            Drupal.behaviors.weaver_takeover.toggleTakeover('menu', nav2);
          }
          if (e.ctrlKey && e.altKey && e.which == 51) {
            let nav3 = document.querySelector('[data-item="nav3"]');
            Drupal.behaviors.weaver_takeover.toggleTakeover('menu', nav3);
          }
          if (e.ctrlKey && e.altKey && e.which == 52) {
            let nav4 = document.querySelector('[data-item="nav4"]');
            Drupal.behaviors.weaver_takeover.toggleTakeover('menu', nav4);
          }
          if (e.ctrlKey && e.altKey && e.which == 53) {
            let nav5 = document.querySelector('[data-item="nav5"]');
            Drupal.behaviors.weaver_takeover.toggleTakeover('menu', nav5);
          }
          // CTRL+ALT+S
          if (e.ctrlKey && e.altKey && e.which == 83) {
            // toggle Takeover Search
            Drupal.behaviors.weaver_takeover.toggleTakeover('search');
          }
          // up arrow
          if (e.ctrlKey && e.altKey && e.which == 38) {
            // scroll to top
            weaver.backTop();
          }
          // down arrow
          if (e.ctrlKey && e.altKey && e.which == 40) {
            // scroll to bottom
            window.scrollTo(9999999,0);
          }
        };
      });
    }
  };

})(jQuery, Drupal, once);
